define.alias("checkout/components/proration", "calendar/components/proration");